import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navigation/Navbar';
import SciFiBackground from '../components/SciFiBackground/SciFiBackground';
import { apiClient } from '../utils/apiClient';

const AuctionConfirmation = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const confirmReservation = async () => {
      try {
        const data = await apiClient.post(`/api/auction-reservations/confirm/${token}`);

        if (data.success) {
          setResult(data.data);
        } else {
          setError(data.message);
        }
      } catch (error) {
        console.error('Error confirming reservation:', error);
        setError('Failed to confirm reservation. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      confirmReservation();
    } else {
      setError('Invalid confirmation link');
      setLoading(false);
    }
  }, [token]);

  if (loading) {
    return (
      <SciFiBackground>
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900">
          <Navbar />
          <div className="container mx-auto px-4 py-8">
            <div className="flex justify-center items-center h-64">
              <div className="glass-card p-8 rounded-2xl text-center">
                <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-cyan-400 mx-auto mb-4"></div>
                <p className="text-lg font-medium text-gray-300">Confirming your reservation...</p>
              </div>
            </div>
          </div>
        </div>
      </SciFiBackground>
    );
  }

  return (
    <SciFiBackground>
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900">
        <Navbar />
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-md mx-auto">
            <div className="glass-card p-8 rounded-2xl text-center">
              {result ? (
                <>
                  <div className="text-6xl mb-4">✅</div>
                  <h2 className="text-2xl font-bold mb-4 text-white">Reservation Confirmed!</h2>
                  <div className="bg-green-500/20 border border-green-500/50 rounded-lg p-4 mb-6">
                    <p className="text-green-300 mb-2">
                      <strong>Product:</strong> {result.productName}
                    </p>
                    <p className="text-green-300 mb-2">
                      <strong>Auction Date:</strong> {new Date(result.auctionStartTime).toLocaleString()}
                    </p>
                    <p className="text-green-300">
                      <strong>Confirmed Participants:</strong> {result.confirmedReservations}/100
                    </p>
                  </div>
                  <p className="text-gray-300 mb-6">
                    Your participation in the auction is now confirmed. You will receive a reminder email closer to the auction date.
                  </p>
                  <div className="space-y-3">
                    <button
                      onClick={() => navigate('/ecommerce')}
                      className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white px-6 py-3 rounded-lg font-medium transition-all transform hover:scale-105"
                    >
                      Browse More Products
                    </button>
                    <button
                      onClick={() => navigate('/profile')}
                      className="w-full bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-400 hover:to-purple-500 text-white px-6 py-3 rounded-lg font-medium transition-all transform hover:scale-105"
                    >
                      View My Reservations
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="text-6xl mb-4">❌</div>
                  <h2 className="text-2xl font-bold mb-4 text-white">Confirmation Failed</h2>
                  <div className="bg-red-500/20 border border-red-500/50 rounded-lg p-4 mb-6">
                    <p className="text-red-300">{error}</p>
                  </div>
                  <p className="text-gray-300 mb-6">
                    Please check your confirmation link or contact support if the problem persists.
                  </p>
                  <button
                    onClick={() => navigate('/ecommerce')}
                    className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white px-6 py-3 rounded-lg font-medium transition-all transform hover:scale-105"
                  >
                    Back to Products
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </SciFiBackground>
  );
};

export default AuctionConfirmation;
